import apiClient from '../apiClient';
import { DELETE_SYSTEM_MARGIN_BY_ID_URL } from '../apiUrl';

const deleteSystmeMarginApi = Id => {
  return apiClient.delete(DELETE_SYSTEM_MARGIN_BY_ID_URL(Id));
};

export default deleteSystmeMarginApi;
